import { render, staticRenderFns } from "./EditarTransaccionModal.vue?vue&type=template&id=3ef28851"
import script from "./EditarTransaccionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarTransaccionModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports